import React, { useState } from 'react';
import { FaShieldAlt, FaDatabase, FaExclamationTriangle } from 'react-icons/fa';
import { CustomButton } from '../../../components/CustomButton';
import { CustomToggle } from '../../../components/CustomToggle';
import { CopyCompany } from '../components/CopyCompany';
import EraseDatabase from '../components/EraseDatabase';
import {
  ContainerLoja,
  ContentLoja,
  SettingsCard,
  CardHeader,
  ToggleRow,
  DangerZone,
} from './styles';
import { InfoDescription } from '../../../components/InfoDescription';

const Advanced = ({ config, change }) => {
  const [copyCompanyModal, setCopyCompanyModal] = useState(false);
  const [eraseDatabase, setEraseDatabase] = useState(false);

  return (
    <>
      <ContainerLoja>
        <ContentLoja>
          <SettingsCard>
            <CardHeader>
              <FaShieldAlt />
              <h3>Controle e Segurança</h3>
            </CardHeader>

            <ToggleRow>
              <InfoDescription
                label="Permitir Criação de Conta"
                description="Habilita a opção para novos clientes se cadastrarem no seu aplicativo."
              />
              <CustomToggle
                id="allowSignup"
                checked={Boolean(config.canSignUp)}
                onChange={() => change('canSignUp', Number(!config.canSignUp))}
              />
            </ToggleRow>

            <ToggleRow>
              <InfoDescription
                label="Venda Exclusiva para Logados"
                description="Bloqueia o carrinho para visitantes. O cliente é obrigado a fazer login para comprar."
              />
              <CustomToggle
                id="SellOnlyWithLogin"
                checked={Boolean(config.sellOnlyWithLogin)}
                onChange={() =>
                  change('sellOnlyWithLogin', Number(!config.sellOnlyWithLogin))
                }
              />
            </ToggleRow>
            <ToggleRow>
              <InfoDescription
                label="Ocultar Ações do Pedido (Gestor)"
                description="Desabilita os botões de mudança de status (ex: Aceitar, Despachar) na tela de pedidos."
              />
              <CustomToggle
                id="DisableOrdersActions"
                checked={config.disableOrdersActions}
                onChange={() =>
                  change('disableOrdersActions', !config.disableOrdersActions)
                }
              />
            </ToggleRow>
            <ToggleRow>
              <InfoDescription
                label="Ocultar Valor Total (Gestor)"
                description="Desabilita a exibição do valor total na tela de pedidos."
              />
              <CustomToggle
                id="DisableOrdersTotal"
                checked={config.disableOrdersTotal}
                onChange={() =>
                  change('disableOrdersTotal', !config.disableOrdersTotal)
                }
              />
            </ToggleRow>
          </SettingsCard>
          <SettingsCard>
            <CardHeader>
              <FaDatabase />
              <h3>Gerenciamento de Dados</h3>
            </CardHeader>
            <ToggleRow>
              <InfoDescription
                label="Clonar Cardápio (Grupos e Produtos)"
                description="Importa toda a base de produtos e grupos de outra filial/loja para esta."
              />
              <CustomButton
                appearance="primary"
                size="sm"
                onClick={() => setCopyCompanyModal(true)}
              >
                Copiar Dados
              </CustomButton>
            </ToggleRow>
            <DangerZone>
              <div className="info">
                <label>
                  <FaExclamationTriangle
                    style={{ color: '#ef4444', marginRight: 6 }}
                  />
                  Zerar Base de Dados
                </label>
                <span>
                  <strong>Atenção:</strong> Apaga todos os registros de
                  produtos, pedidos e configurações. Essa ação é irreversível.
                </span>
              </div>
              <CustomButton
                appearance="ghost"
                color="red"
                size="sm"
                onClick={() => setEraseDatabase(true)}
              >
                Zerar
              </CustomButton>
            </DangerZone>
          </SettingsCard>
        </ContentLoja>
      </ContainerLoja>
      {copyCompanyModal && (
        <CopyCompany
          open={copyCompanyModal}
          onClose={() => setCopyCompanyModal(false)}
        />
      )}
      {eraseDatabase && (
        <EraseDatabase
          show={eraseDatabase}
          onClose={() => setEraseDatabase(false)}
        />
      )}
    </>
  );
};

export default Advanced;
